export default "__VITE_ASSET__DrpWYkH8__"